<mat-form-field class="vzc-email-address__full-field" floatLabel="always" appearance="outline" color="accent">
  <mat-label i18n="@@S_ACCOUNT_ACTIVATION_INPUT_EMAIL_LABEL" id="aa-username-label" for="aa-username">Your email address</mat-label>
  <input
    matInput
    [formControl]="email"
    id="aa-username"
    name="aa-username"
    type="email"
    required="required"
    autocomplete="off"
    i18n-placeholder="@@S_ACCOUNT_ACTIVATION_INPUT_EMAIL_PLACEHOLDER"
    placeholder="example@email.com"
    aria-labelledby="aa-username-label"
  />

  <mat-hint *ngIf="email.invalid" i18n="@@S_ACCOUNT_ACTIVATION_INPUT_EMAIL_HINT">
    The email address must match the one used to create your account.
  </mat-hint>
  <mat-error *ngIf="email.invalid" i18n="@@V_ACCOUNT_ACTIVATION_INPUT_EMAIL_ERROR">Enter a valid email address.</mat-error>
</mat-form-field>
